import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { Provider } from 'react-redux';
import configureStore from '../../../../../redux/configureStore';
import { EmailPartModal } from './EmailPartModal';

storiesOf('Docket/Popups/EmailPartModal', module).add('View', () => (
  <Provider store={configureStore()}>
    <EmailPartModal
      onClose={action('Close Popup')}
      popup={{
        show: true,
        data: {
          case_uuid: 'orbtrain_460215',
          court_code: 'orbtrain',
          case_number: '3:19-bk-30014',
          friendly_name: '',
          sequence_number: '3.00000',
          part_number: 1,
          docket: {
            docket_no: 3,
            date_filed: '03/04/2019',
            docket_text: `Notice of Chapter 13 Bankruptcy Case and Notice of Meeting of Creditors Set for 
            4/2/2019 at 09:00 AM at Chapter 13 Trustee, Portland, Chapter 13 Trustee Office, 222 SW Columbia St., 
            #1700, Portland, OR 97201,Confirmation Hearing Set for 5/9/2019 at 09:00AM at Courtroom #4, Portland, 
            US Bankruptcy Court, Courtroom #4, 1050 SW 6th Ave., 7th Floor, Portland, OR 97204. Proofs of Claims 
            due by 5/13/2019. (kjh) (Entered: 03/04/2019)`,
          },
        },
      }}
      selectedDocket={{
        binder: {
          documents: [
            {
              number: 1,
              download_url: 'Bankr.D.Or.TRAIN._3-19-bk-30014_3_2.pdf',
              filename: 'Bankr.D.Or.TRAIN._3-19-bk-30014_3_2.pdf',
            },
          ],
        },
      }}
      orderPdf={action('Order PDF')}
      onSendEmail={action('Send Email')}
    />
  </Provider>
));



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailPartModal/EmailPartModal.stories.jsx